const { useSearchParams } = require("react-router-dom");

const useFiltersQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setQueryParam = (key, value) => {
    const params = new URLSearchParams(searchParams);
    params.set(key, value);
    setSearchParams(params);
  }

  const deleteQueryParam = (key) => {
    const params = new URLSearchParams(searchParams);
    params.delete(key);
    setSearchParams(params);
  }

  const clearQueryParams = (key) => {
    deleteQueryParam(key)
  }


  return { searchParams, setSearchParams, setQueryParam, deleteQueryParam, clearQueryParams };
}

export default useFiltersQueryParams;
